import { useState, useEffect } from 'react'

import { BsCheckCircle, BsXLg, BsInfoCircle } from "react-icons/bs";

const Index = ({ setToast, message, type = "Info", title }) => {

    const [opacity, setOpacity] = useState(false);


    const statusIcon = () => {
        switch (type) {
            case "Success": return (<BsCheckCircle className="h-6 w-6 text-green-400" aria-hidden="true" />)
            case "Error": return (<BsXLg className="h-6 w-6 text-red-400" aria-hidden="true" />)
            case "Info": return (<BsInfoCircle className="h-6 w-6 text-blue-400" aria-hidden="true" />)

            default:
                break;
        }
    }


    useEffect(() => {

        setOpacity(true)

        const timeout2 = setTimeout(() => {
            setOpacity(false);
        }, 4000);
        const timeout3 = setTimeout(() => {
            setToast({
                showToast: false,
            }); 
        }, 4200);

        return () => {
            clearTimeout(timeout2);
            clearTimeout(timeout3);
        };
    }, [setToast]);

    return (
        <>
            <div
                aria-live="assertive"
                className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50"
            >
                <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    {
                        opacity ? (
                                <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden transition-all duration-200">
                                    <div className="p-4">
                                        <div className="flex items-center">
                                            <div className="flex-shrink-0">
                                                {statusIcon()}
                                            </div>
                                            <div className="ml-3 w-0 flex-1 pt-0.5">
                                                <p className="text-sm font-medium text-gray-900">{title}</p>
                                                <p className="mt-1 text-sm text-gray-500">{message}</p>
                                            </div>
                                            <div className="ml-4 flex-shrink-0 flex">
                                                <button
                                                    className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                    onClick={() => {
                                                        setToast({
                                                            showToast: false,
                                                            message: "",
                                                            type: ""
                                                        })
                                                    }}
                                                >
                                                    <span className="sr-only">Close</span>
                                                    <BsXLg className="h-5 w-5" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        ) : null
                    }
                </div>
            </div >
        </>
    );
}

export default Index;
